import { useDispatch, useSelector } from "react-redux"
import axios from "axios"
import { useEffect, useState } from "react"
import Alert from "./Alert"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { reload } from "../Redux_store/Reload";

const Subject = () => { 

    const [alert , setalert] = useState(false)
    const [dl , setdelete] = useState(false)
    const [sname , setname] = useState()
    const [scode , setcode] = useState()
    const [credit , setcredit] = useState()
    const [facultyname , setfname] = useState()

    const [modal , setmodal] = useState(false)
    const [sub , setsub] = useState()

    const dispatch = useDispatch()
    const component = useSelector((state) => state.comp.comp)
    const rel = useSelector((state)=>state.reload.reload)

    const cancel = () => {
        setmodal(false)
    }

    // useEffect(() => {
    //     document.getElementById("bd").style.filter = modal ? "blur(5px)" : "blur(0px)";
    // }, [modal]);
    
    const isrequired = async () => {
        if(!sname || !scode || !credit || !facultyname){
            setalert(true);
            setTimeout(() => {
                setalert(false)
            }, 1500);
            return false;
        }
        else {
            return true;
        }
    }

    const add = async (e) => {
        e.preventDefault()
        
        try { 
            if(await isrequired()) {
                const addsubject = await axios.post(`${process.env.REACT_APP_API_URL}/addsubject`,{ 
                    sname,
                    scode,
                    credit,
                    facultyname
                },{
                    withCredentials: true
                })
                if(addsubject.status === 200){
                    console.log("Subject added successfully")
                    if(rel) {
                        dispatch(reload(false))
                    }
                    else {
                        dispatch(reload(true))
                    }
                }
                setmodal(false)
        }
        } catch (error) {
            console.log("Not able to add subject : " , error.message)
        }
    }

    const show = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/allsubject`,
                {},
                {
                    withCredentials:true
                })
                if(response.status === 200){
                    setsub(response.data)
                }
                else {
                    console.log("Some Error ocurred")
                }
        } catch (error) {
            console.log("Not able to fetch Subjects : " , error.message)
        }
    } 
    
   const dlt = async (scode) => {
    try {
        const dresponse = await axios.delete(`${process.env.REACT_APP_API_URL}/dsubject`,
            {
                data: {scode} ,   
                withCredentials: true
            }
        );
        if (dresponse.status === 200) {
            console.log("Subject Deleted");
        }
    } catch (error) {
        console.log("Something Went Wrong:", error);
    }

    if(!dl) {
        setdelete(true)
    }
    else {
        setdelete(false)
    }
};


    useEffect(()=>{
        show()
    },[modal,dl])

  return (
    <>
        {
            component === "addsubject" && 
            <div className="subject" >
                {modal && <div className="blurOverlay"></div>}
                <div className="pannel_title">
                    Subjects
                </div>
                <pre className="line" style={{marginTop:"24px"}}> </pre>
                <div className="allsubject" onClick={cancel}>
                    {
                    sub.map((item) =>
                        <div key={item._id} className="subjectCard">
                            <div className="Cardt">
                                {`${item.sname}`}
                            </div>
                            <div className="Cardt credit">
                                code : {`${item.scode}`}
                            </div>
                            <div className="credit">
                                credit : {`${item.credit}`}
                            </div>
                            <div className="facultyname">
                                Faculty : {`${item.facultyname}`} 
                            </div>
                            <button className="trash" onClick={()=>dlt(item.scode)}><FontAwesomeIcon style={{backgroundColor:"none" , outline : "none" , borderColor : "none" , border:"none"}} icon={faTrashCan} /></button>
                        </div>
                        )
                    }

            </div>
            <div className="btnbox">
                <button onClick={() => setmodal(true)} className="btn2">&#43; Add Subject</button>    
            </div>
            <div className="add-subject-container" onClick={cancel}>

                    <p className="description">
                        Easily manage academic subjects by adding all essential details in one place.
                        This feature helps maintain accurate records and smooth coordination.
                    </p>

                    <h3>Subject Details</h3>
                    <ul>
                        <li><strong>Subject Name:</strong> Enter the official name of the subject.</li>
                        <li><strong>Subject Code:</strong> Add a unique code for identification.</li>
                        <li><strong>Credits:</strong> Specify the academic credit value.</li>
                        <li><strong>Faculty Name:</strong> Enter the assigned faculty member.</li>
                    </ul>

                    <p className="note">
                        Once submitted, the subject will be added to the system for tracking and academic planning.
                    </p>
                </div>

                    {modal &&
                        <form id="modal" className="modal_pop" onClick={(e)=>e.stopPropagation()}>
                            <div className="formItem title1">
                                <p>Subject Detail</p>
                            </div>
                            {alert && <Alert message={"All fields are required"}/>} 
                            <div className="formItem">
                                <label className="name">Subject Name</label>
                                <input onChange={(e) => setname(e.target.value)} type="name"/>
                            </div>
                            <div className="formItem">
                                <label className="name">Subject Code</label>
                                <input onChange={(e)=> {setcode(e.target.value)}} type="name"/>
                            </div>
                            <div className="formItem">
                                <label className="name">Credit</label>
                                <input onChange={(e)=> {setcredit(e.target.value)}} type="name"/>
                            </div>
                            <div className="formItem">
                                <label className="name">Faculty Name</label>
                                <input onChange={(e)=> {setfname(e.target.value)}} type="name"/>
                            </div>
                            <div className="btns">
                                <button onClick={add} type="submit" className="btn3">Add</button>
                                <button onClick={cancel} type="submit" className="btn3">Cancel</button>
                            </div>
                        </form>
                        }
                </div> 
        }
    </>
  )
}

export default Subject;